import { Button, Modal, ModalContent, ModalContentText, ModalTitle, ModalActions} from '@deere/fuel-react'

export const GenericFuelModal = ({ title,message,show,secondaryBtn,handleClose,primaryButton, handleSave, customStyle, isLoading, setIsLoading}) => {
    return <Modal
            open={show}
            aria-describedby="alert-Modal-description"
            aria-labelledby="alert-Modal-title"
            onClose={handleClose}
            sx={customStyle}
            >
                <ModalTitle id="alert-Modal-title">
                    {title}
                </ModalTitle>
                <ModalContent>
                    <ModalContentText id="alert-Modal-description">
                        {message}
                    </ModalContentText>
                </ModalContent>
                <ModalActions>
                  {secondaryBtn &&  <Button
                        onClick={handleClose}
                        variant="secondary"
                    >
                        {secondaryBtn}
                    </Button>}
                    {primaryButton && <Button
                        onClick={handleSave}
                        variant="primary"
                        disabled={isLoading}
                    >
                        {primaryButton}
                    </Button>}
                </ModalActions>
            </Modal>
}